import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { reduceResolution, wbp } from 'Theme';

export const useSingleSaleTableTotalStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',

            [theme.breakpoints.up('md')]: {
                width: '500px'
            }
        },
        boxTotal: {
            display: 'flex',
            justifyContent: 'space-between',
            [theme.breakpoints.down(wbp)]: {
                padding: `${reduceResolution(20)}px 0px`
            },
            [theme.breakpoints.up(wbp)]: {
                padding: '20px 0px'
            }
        },
        line: {
            borderBottom: '1px solid #D4D4D4'
        }
    })
);
